var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { feature } from '@square/ember-features/macros';
import { AppointmentsClientSideFeatureId, AppointmentsFeatureId, AppointmentsPlanToken } from '@square/appointments-feature-upsell/types/features';
import { FEATURE_DETAILS } from '@square/appointments-feature-upsell/constants';
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';

// Reference for updating/adding features in this file:
// https://docs.google.com/document/d/1l1625SK9KNL4PEfmatw974izLSeTogLeh914dMa5wcM/edit?usp=sharing
// See "Plan selection page" section

// TODO: AP-26674 Rename service to appointments-feature-info

// TODO Remove constants for plan token and features, use enums instead
// If possible, refactor AppointmentsFeatureId to use the SubscriptionFeature enum from protos
// https://jira.sqprod.co/browse/AP-23122
export const APPOINTMENTS_FREE_TOKEN = AppointmentsPlanToken.APPOINTMENTS_FREE_TOKEN;
export const APPOINTMENTS_PLUS_TOKEN = AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN;
export const APPOINTMENTS_PREMIUM_TOKEN = AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN;
export const DEFAULT_FEATURE_LIST = 'default';
export const DEFAULT_SELECTED_PLAN = AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN;

// FEATURE LIST
export const APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS = AppointmentsFeatureId.APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS;
export const APPOINTMENTS_CONFIRMATIONS = AppointmentsFeatureId.APPOINTMENTS_CONFIRMATIONS;
export const APPOINTMENTS_DAILY_RESERVATION_LIMIT = AppointmentsFeatureId.APPOINTMENTS_DAILY_RESERVATION_LIMIT;
export const APPOINTMENTS_GOOGLE_CALENDAR_SYNC = AppointmentsFeatureId.APPOINTMENTS_GOOGLE_CALENDAR_SYNC;
export const APPOINTMENTS_MULTI_STAFF_RESERVATIONS = AppointmentsFeatureId.APPOINTMENTS_MULTI_STAFF_RESERVATIONS;
export const APPOINTMENTS_NO_SHOW_PROTECTION = AppointmentsFeatureId.APPOINTMENTS_NO_SHOW_PROTECTION;
export const APPOINTMENTS_PROCESSING_TIME = AppointmentsFeatureId.APPOINTMENTS_PROCESSING_TIME;
export const APPOINTMENTS_RESOURCE_MANAGEMENT = AppointmentsFeatureId.APPOINTMENTS_RESOURCE_MANAGEMENT;
export const APPOINTMENTS_WAITLIST = AppointmentsFeatureId.APPOINTMENTS_WAITLIST;
export const APPOINTMENTS_REPORTING = AppointmentsFeatureId.APPOINTMENTS_REPORTING;
export const APPOINTMENTS_CLASS_BOOKING = AppointmentsFeatureId.APPOINTMENTS_CLASS_BOOKING;
export const COMMISSION_TRACKING = AppointmentsFeatureId.COMMISSION_TRACKING;
export const CONTRACTS_CUSTOM_FIELDS = AppointmentsFeatureId.CONTRACTS_CUSTOM_FIELDS;
export const EMPLOYEE_MANAGEMENT = AppointmentsFeatureId.EMPLOYEE_MANAGEMENT;
export const APPOINTMENTS_REPORTING_TEAM_PERFORMANCE = AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_TEAM_PERFORMANCE;
export const APPOINTMENTS_REPORTING_FUTURE_BOOKINGS = AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_FUTURE_BOOKINGS;
export const APPOINTMENTS_SMS_TEMPLATING = AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING;
export const APPOINTMENTS_CUSTOMER_BLOCKING = AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_BLOCKING;
export const APPOINTMENTS_SERVICE_COST = AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST;
export const APPOINTMENTS_CREDIT_PACKAGE = AppointmentsFeatureId.APPOINTMENTS_CREDIT_PACKAGE;
export const APPOINTMENTS_CUSTOMER_FIELDS = AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS;
const DEFAULT_PLUS_FEATURES = [AppointmentsClientSideFeatureId.MULTIPLE_LOCATIONS, AppointmentsFeatureId.APPOINTMENTS_CONFIRMATIONS, AppointmentsFeatureId.APPOINTMENTS_MULTI_STAFF_RESERVATIONS, AppointmentsFeatureId.APPOINTMENTS_NO_SHOW_PROTECTION, AppointmentsFeatureId.APPOINTMENTS_GOOGLE_CALENDAR_SYNC, AppointmentsFeatureId.APPOINTMENTS_PROCESSING_TIME, AppointmentsFeatureId.APPOINTMENTS_WAITLIST, AppointmentsFeatureId.APPOINTMENTS_REPORTING, AppointmentsFeatureId.APPOINTMENTS_CLASS_BOOKING, AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING, AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_BLOCKING, AppointmentsFeatureId.APPOINTMENTS_CREDIT_PACKAGE, AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS];

// This list is used in appointments-subs-plans.js to show the list of features in each plan.
// It may have different features than FEATURE_DETAILS
const PLAN_FEATURE_LIST = {
  [AppointmentsPlanToken.APPOINTMENTS_FREE_TOKEN]: {
    [DEFAULT_FEATURE_LIST]: [AppointmentsClientSideFeatureId.UNLIMITED_STAFF_ACCOUNTS, AppointmentsClientSideFeatureId.ONLINE_BOOKING_SITE, AppointmentsClientSideFeatureId.REMINDERS]
  },
  [AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN]: {
    US: [AppointmentsClientSideFeatureId.DISCOUNTED_PROCESSING_RATE, ...DEFAULT_PLUS_FEATURES],
    GB: [AppointmentsClientSideFeatureId.DISCOUNTED_PROCESSING_RATE, ...DEFAULT_PLUS_FEATURES],
    [DEFAULT_FEATURE_LIST]: DEFAULT_PLUS_FEATURES
  },
  [AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN]: {
    [DEFAULT_FEATURE_LIST]: [AppointmentsClientSideFeatureId.ADVANCED_STAFF_MANAGEMENT, AppointmentsFeatureId.APPOINTMENTS_RESOURCE_MANAGEMENT, AppointmentsClientSideFeatureId.CUSTOM_PRICING, AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST]
  }
};

// This type is exported as it is needed for the `features` property of AppointmentsComparePlansModalComponent
let AppointmentsFeatureInfoService = (_dec = feature('appointments/service_cost_v1'), _dec2 = feature('appointments/customer_fields'), _class = class AppointmentsFeatureInfoService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "serviceCostV1Feature", _descriptor2, this);
    _initializerDefineProperty(this, "enableCustomerFields", _descriptor3, this);
    _initializerDefineProperty(this, "appointmentsPlanFeatures", _descriptor4, this);
    _initializerDefineProperty(this, "featureDataLoaded", _descriptor5, this);
  }
  _getPlanForCountry(planId, countryCode) {
    const planIdFeatureList = PLAN_FEATURE_LIST[planId];
    if (!planIdFeatureList) {
      throw new Error(`No feature list defined for ${planId}`);
    }

    // Spread syntax needs to be used here to avoid weird splicing issues below
    const planForCountry = countryCode && planIdFeatureList[countryCode] ? [...planIdFeatureList[countryCode]] : [...planIdFeatureList[DEFAULT_FEATURE_LIST]];
    if (planForCountry.includes(AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING)) {
      planForCountry.splice(planForCountry.indexOf(AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING), 1);
    }

    // Only show APPOINTMENTS_SERVICE_COST feature if FF is on
    if (!this.serviceCostV1Feature && planForCountry.includes(AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST)) {
      planForCountry.splice(planForCountry.indexOf(AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST), 1);
    }

    // Only show APPOINTMENTS_CUSTOMER_FIELDS feature if FF is on
    if (!this.enableCustomerFields && planForCountry.includes(AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS)) {
      planForCountry.splice(planForCountry.indexOf(AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS), 1);
    }
    return planForCountry;
  }
  getPlanTokenOfFeature(featureId) {
    return FEATURE_DETAILS[featureId]?.planToken;
  }
  getFeatureHasMoreDetails(featureId) {
    return FEATURE_DETAILS[featureId]?.hasMoreDetails;
  }
  getFeatureListOfPlan(planId, countryCode) {
    const planForCountry = this._getPlanForCountry(planId, countryCode);
    return planForCountry.map(this.getFeatureListTranslation);
  }
  getTooltipsOfPlan(planId, countryCode) {
    const planForCountry = this._getPlanForCountry(planId, countryCode);
    return planForCountry.map(this.getFeatureListTooltip);
  }
  getPlanName(planId) {
    switch (planId) {
      case AppointmentsPlanToken.APPOINTMENTS_FREE_TOKEN:
        return this.intl.t('apptsUpsell.subscription.tierName.free');
      case AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN:
        return this.intl.t('apptsUpsell.subscription.tierName.plus');
      case AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN:
        return this.intl.t('apptsUpsell.subscription.tierName.premium');
      default:
        throw new Error(`No plan name found for ${planId}`);
    }
  }
  getPreviousPlanName(planId) {
    switch (planId) {
      case AppointmentsPlanToken.APPOINTMENTS_FREE_TOKEN:
        return undefined;
      case AppointmentsPlanToken.APPOINTMENTS_PLUS_TOKEN:
        return this.intl.t('apptsUpsell.subscription.tierName.free');
      case AppointmentsPlanToken.APPOINTMENTS_PREMIUM_TOKEN:
        return this.intl.t('apptsUpsell.subscription.tierName.plus');
      default:
        throw new Error(`No plan name found for ${planId}`);
    }
  }

  // eslint-disable-next-line complexity
  getFeatureTitle(featureId) {
    switch (featureId) {
      case AppointmentsFeatureId.APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS:
        return this.intl.t('apptsUpsell.subscription.feature.title.automatedDigitalContracts');
      case AppointmentsFeatureId.COMMISSION_TRACKING:
        return this.intl.t('apptsUpsell.subscription.feature.title.commissionTracking');
      case AppointmentsFeatureId.APPOINTMENTS_CONFIRMATIONS:
        return this.intl.t('apptsUpsell.subscription.feature.title.customerConfirmations');
      case AppointmentsFeatureId.APPOINTMENTS_DAILY_RESERVATION_LIMIT:
        return this.intl.t('apptsUpsell.subscription.feature.title.dailyAppointmentLimit');
      case AppointmentsFeatureId.APPOINTMENTS_GOOGLE_CALENDAR_SYNC:
        return this.intl.t('apptsUpsell.subscription.feature.title.googleCalendarSync');
      case AppointmentsFeatureId.APPOINTMENTS_MULTI_STAFF_RESERVATIONS:
        return this.intl.t('apptsUpsell.subscription.feature.title.multiStaffAppointments');
      case AppointmentsFeatureId.APPOINTMENTS_NO_SHOW_PROTECTION:
        return this.intl.t('apptsUpsell.subscription.feature.title.noShowProtection');
      case AppointmentsFeatureId.APPOINTMENTS_PROCESSING_TIME:
        return this.intl.t('apptsUpsell.subscription.feature.title.processingTime');
      case AppointmentsFeatureId.APPOINTMENTS_RESOURCE_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.feature.title.resourceManagement');
      case AppointmentsFeatureId.EMPLOYEE_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.feature.title.teamManagement');
      case AppointmentsFeatureId.APPOINTMENTS_WAITLIST:
        return this.intl.t('apptsUpsell.subscription.feature.title.waitlist');
      case AppointmentsFeatureId.CONTRACTS_CUSTOM_FIELDS:
        return this.intl.t('apptsUpsell.subscription.feature.title.contractsCustomFields');
      case AppointmentsClientSideFeatureId.ADVANCED_STAFF_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.featureList.advancedStaffManagement');
      case AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_TEAM_PERFORMANCE:
        return this.intl.t('apptsUpsell.subscription.feature.title.teamPerformanceReport');
      case AppointmentsFeatureId.APPOINTMENTS_CLASS_BOOKING:
        return this.intl.t('apptsUpsell.subscription.feature.title.classBooking');
      case AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_FUTURE_BOOKINGS:
        return this.intl.t('apptsUpsell.subscription.feature.title.futureBookingsReport');
      case AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING:
        return this.intl.t('apptsUpsell.subscription.feature.title.smsTemplating');
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_BLOCKING:
        return this.intl.t('apptsUpsell.subscription.feature.title.blockCustomers');
      case AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST:
        return this.intl.t('apptsUpsell.subscription.feature.title.serviceCost');
      case AppointmentsFeatureId.APPOINTMENTS_CREDIT_PACKAGE:
        return this.intl.t('apptsUpsell.subscription.feature.title.packages');
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS:
        return this.intl.t('apptsUpsell.subscription.feature.title.customerFields');
      default:
        throw new Error(`No translation found for title of ${featureId}`);
    }
  }

  // eslint-disable-next-line complexity
  getFeatureDescription(featureId) {
    switch (featureId) {
      case AppointmentsFeatureId.APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS:
        return this.intl.t('apptsUpsell.subscription.feature.description.automatedDigitalContracts');
      case AppointmentsFeatureId.COMMISSION_TRACKING:
        return this.intl.t('apptsUpsell.subscription.feature.description.commissionTracking');
      case AppointmentsFeatureId.APPOINTMENTS_CONFIRMATIONS:
        return this.intl.t('apptsUpsell.subscription.feature.description.customerConfirmations');
      case AppointmentsFeatureId.APPOINTMENTS_DAILY_RESERVATION_LIMIT:
        return this.intl.t('apptsUpsell.subscription.feature.description.dailyAppointmentLimit');
      case AppointmentsFeatureId.APPOINTMENTS_GOOGLE_CALENDAR_SYNC:
        return this.intl.t('apptsUpsell.subscription.feature.description.googleCalendarSync');
      case AppointmentsFeatureId.APPOINTMENTS_MULTI_STAFF_RESERVATIONS:
        return this.intl.t('apptsUpsell.subscription.feature.description.multiStaffAppointments');
      case AppointmentsFeatureId.APPOINTMENTS_NO_SHOW_PROTECTION:
        return this.intl.t('apptsUpsell.subscription.feature.description.noShowProtection');
      case AppointmentsFeatureId.APPOINTMENTS_PROCESSING_TIME:
        return this.intl.t('apptsUpsell.subscription.feature.description.processingTime');
      case AppointmentsFeatureId.APPOINTMENTS_RESOURCE_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.feature.description.resourceManagement');
      case AppointmentsFeatureId.EMPLOYEE_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.feature.description.teamManagementAdvancedAccess');
      case AppointmentsFeatureId.APPOINTMENTS_WAITLIST:
        return this.intl.t('apptsUpsell.subscription.feature.description.waitlist');
      case AppointmentsFeatureId.CONTRACTS_CUSTOM_FIELDS:
        return this.intl.t('apptsUpsell.subscription.feature.description.contractsCustomFields');
      case AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_TEAM_PERFORMANCE:
        return this.intl.t('apptsUpsell.subscription.feature.description.teamPerformanceReport');
      case AppointmentsFeatureId.APPOINTMENTS_CLASS_BOOKING:
        return this.intl.t('apptsUpsell.subscription.feature.description.classBooking');
      case AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_FUTURE_BOOKINGS:
        return this.intl.t('apptsUpsell.subscription.feature.description.futureBookingsReport');
      case AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING:
        return this.intl.t('apptsUpsell.subscription.feature.description.smsTemplating');
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_BLOCKING:
        return this.intl.t('apptsUpsell.subscription.feature.description.blockCustomers');
      case AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST:
        return this.intl.t('apptsUpsell.subscription.feature.description.serviceCost');
      case AppointmentsFeatureId.APPOINTMENTS_CREDIT_PACKAGE:
        return this.intl.t('apptsUpsell.subscription.feature.description.packages');
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS:
        return this.intl.t('apptsUpsell.subscription.feature.description.customerFields');
      default:
        throw new Error(`No translation found for description of ${featureId}`);
    }
  }

  // eslint-disable-next-line complexity
  getFeatureDetailedDescription(featureId) {
    switch (featureId) {
      case AppointmentsFeatureId.APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.automatedDigitalContracts');
      case AppointmentsFeatureId.COMMISSION_TRACKING:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.commissionTracking');
      case AppointmentsFeatureId.APPOINTMENTS_CONFIRMATIONS:
        return this.intl.t('apptsUpsell.subscription.feature.description.customerConfirmations');
      case AppointmentsFeatureId.APPOINTMENTS_DAILY_RESERVATION_LIMIT:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.dailyAppointmentLimit');
      case AppointmentsFeatureId.APPOINTMENTS_GOOGLE_CALENDAR_SYNC:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.googleCalendarSync');
      case AppointmentsFeatureId.APPOINTMENTS_MULTI_STAFF_RESERVATIONS:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.multiStaffAppointments');
      case AppointmentsFeatureId.APPOINTMENTS_NO_SHOW_PROTECTION:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.noShowProtection');
      case AppointmentsFeatureId.APPOINTMENTS_PROCESSING_TIME:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.processingTime');
      case AppointmentsFeatureId.APPOINTMENTS_RESOURCE_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.resourceManagement');
      case AppointmentsFeatureId.EMPLOYEE_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.teamManagement');
      case AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING:
        return this.intl.t('apptsUpsell.subscription.feature.description.detailed.smsTemplating');
      case AppointmentsFeatureId.APPOINTMENTS_WAITLIST:
        return this.intl.t('apptsUpsell.subscription.feature.description.waitlist');
      case AppointmentsFeatureId.CONTRACTS_CUSTOM_FIELDS:
        return this.intl.t('apptsUpsell.subscription.feature.description.contractsCustomFields');
      case AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_TEAM_PERFORMANCE:
        return this.intl.t('apptsUpsell.subscription.feature.description.teamPerformanceReport');
      case AppointmentsFeatureId.APPOINTMENTS_CLASS_BOOKING:
        return this.intl.t('apptsUpsell.subscription.feature.description.classBooking');
      case AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_FUTURE_BOOKINGS:
        return this.intl.t('apptsUpsell.subscription.feature.description.futureBookingsReport');
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_BLOCKING:
        return this.intl.t('apptsUpsell.subscription.feature.description.blockCustomers');
      case AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST:
        return this.intl.t('apptsUpsell.subscription.feature.description.serviceCost');
      case AppointmentsFeatureId.APPOINTMENTS_CREDIT_PACKAGE:
        return this.intl.t('apptsUpsell.subscription.feature.description.packages');
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS:
        return this.intl.t('apptsUpsell.subscription.feature.description.customerFields');
      default:
        throw new Error(`No translation found for detailed description of ${featureId}`);
    }
  }
  // eslint-disable-next-line complexity
  getFeatureListTranslation(featureId) {
    switch (featureId) {
      case AppointmentsClientSideFeatureId.DISCOUNTED_PROCESSING_RATE:
        return this.intl.t('apptsUpsell.subscription.featureList.discountedProcessingRates');
      case AppointmentsFeatureId.APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS:
        return this.intl.t('apptsUpsell.subscription.featureList.automatedContracts');
      case AppointmentsFeatureId.COMMISSION_TRACKING:
        return this.intl.t('apptsUpsell.subscription.featureList.commissionTracking');
      case AppointmentsFeatureId.APPOINTMENTS_CONFIRMATIONS:
        return this.intl.t('apptsUpsell.subscription.featureList.customerConfirmations');
      case AppointmentsClientSideFeatureId.INTEGRATED_PAYMENTS:
        return this.intl.t('apptsUpsell.subscription.featureList.integratedPayments');
      case AppointmentsFeatureId.APPOINTMENTS_MULTI_STAFF_RESERVATIONS:
        return this.intl.t('apptsUpsell.subscription.featureList.multiStaffAppointments');
      case AppointmentsClientSideFeatureId.MULTIPLE_LOCATIONS:
        return this.intl.t('apptsUpsell.subscription.featureList.multipleLocations');
      case AppointmentsFeatureId.APPOINTMENTS_NO_SHOW_PROTECTION:
        return this.intl.t('apptsUpsell.subscription.featureList.noShowProtection');
      case AppointmentsClientSideFeatureId.ONLINE_BOOKING_SITE:
        return this.intl.t('apptsUpsell.subscription.featureList.onlineBookingSite');
      case AppointmentsFeatureId.APPOINTMENTS_PROCESSING_TIME:
        return this.intl.t('apptsUpsell.subscription.featureList.processingTime');
      case AppointmentsClientSideFeatureId.REMINDERS:
        return this.intl.t('apptsUpsell.subscription.featureList.reminders');
      case AppointmentsFeatureId.APPOINTMENTS_RESOURCE_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.featureList.resourceManagement');
      case AppointmentsClientSideFeatureId.SOCIAL_MEDIA_INTEGRATIONS:
        return this.intl.t('apptsUpsell.subscription.featureList.socialMediaIntegrations');
      case AppointmentsFeatureId.EMPLOYEE_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.featureList.teamManagementAdvancedAccess');
      case AppointmentsClientSideFeatureId.UNLIMITED_STAFF_ACCOUNTS:
        return this.intl.t('apptsUpsell.subscription.featureList.unlimitedStaffAccounts');
      case AppointmentsFeatureId.APPOINTMENTS_WAITLIST:
        return this.intl.t('apptsUpsell.subscription.featureList.waitlist');
      case AppointmentsFeatureId.CONTRACTS_CUSTOM_FIELDS:
        return this.intl.t('apptsUpsell.subscription.featureList.contractsCustomFields');
      case AppointmentsFeatureId.APPOINTMENTS_GOOGLE_CALENDAR_SYNC:
        return this.intl.t('apptsUpsell.subscription.featureList.googleCalendar');
      case AppointmentsClientSideFeatureId.ADVANCED_STAFF_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.featureList.advancedStaffManagement');
      case AppointmentsFeatureId.APPOINTMENTS_REPORTING:
        return this.intl.t('apptsUpsell.subscription.featureList.appointmentsReports');
      case AppointmentsFeatureId.APPOINTMENTS_CLASS_BOOKING:
        return this.intl.t('apptsUpsell.subscription.featureList.classBooking');
      case AppointmentsClientSideFeatureId.CUSTOM_PRICING:
        return this.intl.t('apptsUpsell.subscription.featureList.customPricing');
      case AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING:
        return this.intl.t('apptsUpsell.subscription.featureList.smsTemplating');
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_BLOCKING:
        return this.intl.t('apptsUpsell.subscription.featureList.blockCustomers');
      case AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST:
        return this.intl.t('apptsUpsell.subscription.featureList.serviceCost');
      case AppointmentsFeatureId.APPOINTMENTS_CREDIT_PACKAGE:
        return this.intl.t('apptsUpsell.subscription.featureList.packages');
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS:
        return this.intl.t('apptsUpsell.subscription.featureList.customerFields');
      default:
        throw new Error(`No translation found for ${featureId}`);
    }
  }
  getFeatureListTooltip(featureId) {
    switch (featureId) {
      case AppointmentsClientSideFeatureId.DISCOUNTED_PROCESSING_RATE:
        return this.intl.t('apptsUpsell.subscription.tooltip.discountedProcessingRates');
      case AppointmentsFeatureId.APPOINTMENTS_MULTI_STAFF_RESERVATIONS:
        return this.intl.t('apptsUpsell.subscription.tooltip.multiStaffAppointments');
      case AppointmentsClientSideFeatureId.MULTIPLE_LOCATIONS:
        return this.intl.t('apptsUpsell.subscription.tooltip.multipleLocations');
      case AppointmentsFeatureId.APPOINTMENTS_NO_SHOW_PROTECTION:
        return this.intl.t('apptsUpsell.subscription.tooltip.noShowProtection');
      case AppointmentsFeatureId.APPOINTMENTS_PROCESSING_TIME:
        return this.intl.t('apptsUpsell.subscription.tooltip.processingTime');
      case AppointmentsFeatureId.APPOINTMENTS_RESOURCE_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.tooltip.resourceManagement');
      case AppointmentsClientSideFeatureId.ADVANCED_STAFF_MANAGEMENT:
        return this.intl.t('apptsUpsell.subscription.tooltip.advancedStaffManagement');
      case AppointmentsClientSideFeatureId.CUSTOM_PRICING:
        return this.intl.t('apptsUpsell.subscription.tooltip.customPricing');
      case AppointmentsFeatureId.APPOINTMENTS_CLASS_BOOKING:
        return this.intl.t('apptsUpsell.subscription.tooltip.classBooking');
      case AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST:
        return this.intl.t('apptsUpsell.subscription.tooltip.serviceCost');
      case AppointmentsFeatureId.APPOINTMENTS_CREDIT_PACKAGE:
        return this.intl.t('apptsUpsell.subscription.tooltip.packages');
      default:
        // Default case returns an empty string since not all features have a tooltip
        return '';
    }
  }

  // Should match the image names of the features
  getFeatureDetailsImageName(featureId) {
    switch (featureId) {
      case AppointmentsFeatureId.APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS:
        return 'automatedDigitalContracts';
      case AppointmentsFeatureId.COMMISSION_TRACKING:
        return 'commissionTracking';
      case AppointmentsFeatureId.APPOINTMENTS_CONFIRMATIONS:
        return 'customerConfirmations';
      case AppointmentsFeatureId.APPOINTMENTS_NO_SHOW_PROTECTION:
        return 'noShowProtection';
      case AppointmentsFeatureId.APPOINTMENTS_PROCESSING_TIME:
        return 'processingTime';
      case AppointmentsFeatureId.APPOINTMENTS_RESOURCE_MANAGEMENT:
        return 'resourceManagement';
      case AppointmentsFeatureId.EMPLOYEE_MANAGEMENT:
        return 'teamManagement';
      case AppointmentsFeatureId.APPOINTMENTS_WAITLIST:
        return 'waitlist';
      case AppointmentsFeatureId.CONTRACTS_CUSTOM_FIELDS:
        return 'contractsCustomFields';
      case AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_TEAM_PERFORMANCE:
      case AppointmentsClientSideFeatureId.APPOINTMENTS_REPORTING_FUTURE_BOOKINGS:
        return 'reporting';
      case AppointmentsFeatureId.APPOINTMENTS_CLASS_BOOKING:
        return 'classBooking';
      case AppointmentsFeatureId.APPOINTMENTS_SMS_TEMPLATING:
        return 'smsTemplating';
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_BLOCKING:
        return 'blockCustomers';
      case AppointmentsFeatureId.APPOINTMENTS_SERVICE_COST:
        return 'serviceCost';
      case AppointmentsFeatureId.APPOINTMENTS_CREDIT_PACKAGE:
        return 'packages';
      case AppointmentsFeatureId.APPOINTMENTS_CUSTOMER_FIELDS:
        return 'customerFields';
      default:
        throw new Error(`No image found for details of ${featureId}`);
    }
  }
  async fetchFullFeatureLists(countryCode = 'US') {
    if (this.appointmentsPlanFeatures) {
      return;
    }
    this.featureDataLoaded = false;
    try {
      const res = await jsonPost('/appointments/appointments_plan_features', {
        country_code: countryCode.toUpperCase()
      });
      this.appointmentsPlanFeatures = res.features;
      this.featureDataLoaded = true;
    } catch (e) {
      this.featureDataLoaded = false;
      throw e;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "serviceCostV1Feature", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "enableCustomerFields", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "appointmentsPlanFeatures", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "featureDataLoaded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "getFeatureListTranslation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getFeatureListTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getFeatureListTooltip", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getFeatureListTooltip"), _class.prototype), _class);
export { AppointmentsFeatureInfoService as default };